import { useState } from "react";

import BaseDivider from "@/components_v2/Divider/BaseDivider";
import BasePopover from "@/components_v2/Popover/BasePopover";
import AccountHeader from "./components/AccountHeader";
import AccountMenu from "./components/AccountMenu";
import AccountSignOutButton from "./components/AccountSignOutButton";
import { useAccountSignOut } from "./hooks/useAccountSignOut";
import { useResponsive } from "@/shared/hooks/useBreakpoints";
import type { AccountPopoverProps } from "../types";

import "./styles.css";

const AccountPopover = ({
  currentUser,
  children,
  placement = "rightTop",
}: AccountPopoverProps) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const signOut = useAccountSignOut();

  const { isMobile } = useResponsive();

  const close = () => setIsPopoverOpen(false);

  return (
    <BasePopover
      arrow={false}
      align={
        isMobile
          ? {
              offset: [-4, 8],
            }
          : {
              offset: [8, -16],
            }
      }
      placement={placement}
      getPopupContainer={(triggerNode) =>
        globalThis.document?.body ?? triggerNode
      }
      open={isPopoverOpen}
      onOpenChange={setIsPopoverOpen}
      classNames={{ root: "account-popover-overlay" }}
      trigger="click"
      content={
        <div className="flex flex-col">
          <AccountHeader currentUser={currentUser} />

          <BaseDivider />

          <AccountMenu currentUser={currentUser} onItemClick={close} />

          <BaseDivider />

          <AccountSignOutButton
            onClick={() => {
              signOut();
              close();
            }}
          />
        </div>
      }
    >
      {children({ isOpen: isPopoverOpen })}
    </BasePopover>
  );
};

export default AccountPopover;
